export default "/img/AD.437ae1764befcd4a5e26e3b5d0bf97b0.png";